module.exports = __webpack_public_path__ + "img/m-banner-ltwjyxtc-de-DE.29565680.jpg";